import { render } from "./SavoirFaire.vue?vue&type=template&id=0604f53f"
import script from "./SavoirFaire.vue?vue&type=script&lang=js"
export * from "./SavoirFaire.vue?vue&type=script&lang=js"

import "./SavoirFaire.vue?vue&type=style&index=0&id=0604f53f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__